module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_spot-f2d21f4f5b78d6385bbaf40a7da1d52e.svg";